/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Hourglass(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M200,75.64392V40.0033a16.02084,16.02084,0,0,0-16-16H72a16.02084,16.02084,0,0,0-16,16v36a16.08093,16.08093,0,0,0,6.40625,12.79687l52.26563,39.20313L62.39844,167.20642A16.07348,16.07348,0,0,0,56,180.0033v36a16.02085,16.02085,0,0,0,16,16H184a16.02085,16.02085,0,0,0,16-16V180.36267a16.033,16.033,0,0,0-6.35937-12.76562l-52.377-39.59375,52.377-39.59375A16.05549,16.05549,0,0,0,200,75.64392Z" />
    </Svg>
  );
}

export default Hourglass;
